import React from 'react';

import {RequestAssignee} from 'requests/RequestConstants';

export default function RequestAssignees({assignees}: {assignees: Array<RequestAssignee>}): JSX.Element {
  const names = assignees.map((assignee) => (assignee.user ? assignee.user.name : assignee.team.name));
  const text = names.join(', ');

  return <div className="u-ellipsis-text">{text}</div>;
}
